export default __webpack_public_path__ + "static/Suneel-8895ab6e0f7d952a820d4afdecf99343.png";